import { ReferenceItemSerializer } from './reference-item';

export class ReferenceMenuSerializer {
  static deserialize = data => (
    data && data.map(r => ReferenceItemSerializer.deserialize(r))
  );
}
